module.exports = __webpack_public_path__ + "static/media/S (130).bbec02d8.jpg";